module.exports = __webpack_public_path__ + "img/40.3f049da9.jpg";